import styled from 'styled-components';

export const DetailsTileStyles = styled.div<{ $bg?: string }>`
	display: flex;
	flex-direction: column;
	padding: 0.5rem;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
	border-radius: 0.25rem;
	background: ${({ $bg }) => $bg ?? 'transparent'};
`;
